/**
 * Base class to describe an export data provider
 */
export default class ExportDataProvider
{
    /**
     *  Export data base method
     * @param {DataProvider} dataProvider The data provider to source the data required
     * @param {Array} layout The data layout for exporting
     * @param {any} context Optional contextual data for exporting
     * @return {Promise} Returns a promise indicating when the process has finished
     */
    exportData(dataProvider, layout, context)
    { throw new Error('You have to implement the method exportData'); }
}